import styled from 'styled-components';

/**
 * Borda e texto em degradê azul -> verde da IA: a borda vem do `.btn-outline-ia`
 * global e o texto do `.span-outline-ia`, por isso aqui só sobram tamanho e espacamento.
 */
export const ButtonContainer = styled.button`
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;

  .customize-analysis-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
`;

export const Container = styled.div`
  .custom-analysis-empty {
    background: linear-gradient(90deg, #edf5ff 0%, #f0fbf7 100%);
    border: 1px solid ${(props) => props.theme.$primary_medium};
    border-radius: 8px;
    padding: 24px 16px;
  }

  .custom-analysis-empty-title {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.$dark};
  }

  .custom-analysis-empty-text {
    font-size: 14px;
    color: ${(props) => props.theme.$gray700};
    max-width: 640px;
  }

  .custom-analysis-loading {
    font-size: 14px;
    color: ${(props) => props.theme.$gray600};
  }

  .custom-analysis-content {
    font-size: 14px;
    color: ${(props) => props.theme.$gray900};
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;
